var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b8318164-a1ed-44b1-b121-46b959fc0522",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "141.58 325.33 716.84 349.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4678f94f-8c84-4bf6-ba4c-cbc08a7db045",
    x1: 247.001,
    y1: 500.016,
    x2: 247.001,
    y2: 387.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#fff",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#fff",
    stopOpacity: 0.487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#fff",
    stopOpacity: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#fff",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.458 674.671 417.884 674.671 316.171 500.015 279.732 562.281 345.458 674.671",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.48 500.016 141.58 674.671 214.618 674.671 279.732 562.281 316.171 500.015 243.48 500.016",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.966 387.613 177.832 387.613 243.48 500.016 316.171 500.015 250.966 387.613",
    fill: "url(#uuid-4678f94f-8c84-4bf6-ba4c-cbc08a7db045)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "214.697 325.359 177.522 325.359 141.58 325.359 177.832 387.613 250.966 387.613 214.697 325.359",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850.564,392.379c-5.241-13.258-12.767-24.872-22.587-34.863-9.821-9.981-21.931-17.837-36.332-23.564-14.41-5.727-30.614-8.593-48.612-8.593h-131.335l-96.62,166.528-96.698-166.528-72.962-.03-65.529,112.149,35.952,61.975h0l.329.562.329-.562h0l65.444-111.828,96.658,166.607h72.877s60.239-104.355,60.239-104.355v224.738l63.829.056v-131.31h67.487c17.998,0,34.202-2.861,48.612-8.588,14.4-5.727,26.511-13.583,36.332-23.569,9.82-9.981,17.346-21.605,22.587-34.863,5.232-13.258,7.856-27.252,7.856-41.978s-2.624-28.725-7.856-41.983ZM794.451,439.211c0,28.241-22.894,51.135-51.135,51.135h-67.507v-102.733h67.505c28.242,0,51.136,22.894,51.136,51.136v.463Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b60697f1eb7006fabef6b8b6813ba16.svg";
export { ForwardRef as ReactComponent };